import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cn-print-nav',
  templateUrl: './cn-print-nav.component.html',
  styleUrls: ['./cn-print-nav.component.scss']
})
export class CnPrintNavComponent implements OnInit {

  constructor(public router:Router) { }

  ngOnInit(): void {
  }

  activeRoute(routename: string): boolean{
    return this.router.url.indexOf(routename) > -1;
  }

}
